import { SHARE_URL } from './config';

export const TWITTER = `https://twitter.com/share?url=${SHARE_URL}&text=Play%20Beautiful%20Mind%20Games%20by%20@bmgomg%20at`; // https://twitter.com/bmgomg
export const FACEBOOK = `https://www.facebook.com/sharer/sharer.php?u=${SHARE_URL}&quote=Play Beautiful Mind Games by https://facebook.com/bmgomg`; // 'https://fb.me/bmgomg';
export const EMAIL = 'bmgomg@gmail.com';
export const REDDIT = 'https://reddit.com/r/beautifulmindgames';
export const REFRESHED_ON = 'REFRESHED ON';
export const YOUTUBE = 'https://www.youtube.com/channel/UCS2p8FhmS5mU4EiGJPwmPUw/videos';
export const CM = 'CM';
export const MS = 'MS';
export const MT = 'MT';
export const NM = 'NM';
export const PN = 'PN';
export const PT = 'PT';
export const RE = 'RE';
export const SM = 'SM';
export const TA = 'TA';
export const TM = 'TM';
export const TT = 'TT';
export const APPS = [CM, MS, MT, NM, PN, RE, SM, TA, TM, TT];
export const USER_NAME = 'USER NAME';
export const MAX_LEADERS = 100;
export const LEADERS_CACHE_TIMEOUT = 3600000;
export const SHOW = 'SHOW';
export const HIDE = 'HIDE';
export const FADE = 'FADE';
export const HIDDEN = 'HIDDEN';
export const DEFAULT_VOLUME = 0.1;
export const GLOBAL_OPTIONS_KEY = 'GLOBAL OPTIONS';
export const START_PAGE = 'START PAGE';
export const SIZE_PAGE = 'SIZE PAGE';
export const SKILL_PAGE = 'SKILL PAGE';
export const GAME_PAGE = 'GAME PAGE';
export const HELP_PAGE = 'HELP PAGE';
export const SLOW = 500;
export const FAST = 200;
export const WHITE = 'rgb(255, 255, 255)';
export const RED = 'rgb(255, 100, 100)';
export const GREEN = 'rgb(100, 255, 100)';
export const BLUE = 'rgb(100, 100, 255)';
export const CYAN = 'rgb(100, 255, 255)';
export const MAGENTA = 'rgb(255, 100, 255)';
export const YELLOW = 'rgb(255, 255, 100)';
export const MODE_AI = 'MODE AI';
export const MODE_SOLO = 'MODE SOLO';
export const MODE_FRIEND = 'MODE FRIEND';
